export enum CaseOperation {
    GLOBAL_VALIDATE = 'operation.entity.case.global-validate',
    VALIDATE = 'operation.entity.case.validate',
    GLOBAL_INVALIDATE = 'operation.entity.case.global-invalidate',
    INVALIDATE = 'operation.entity.case.invalidate',
    INFORM = 'operation.entity.case.inform',
    TRANSCRIPT = 'operation.entity.case.transcript',
    PETITIONER_PRINT = 'operation.entity.case.petitioner-print',
    PRINT = 'operation.entity.case.personnel-print',
    PRINT_CASE_AND_SAMPLE_LABELS = 'operation.entity.case.print-case-and-sample-labels',
    CREATE = 'operation.entity.case.create',
    EDIT = 'operation.entity.case.edit',
    DELETE = 'operation.entity.case.delete',
    ATTACH = 'operation.entity.case.attach',
    VIEW_ALL_DIAGNOSE = 'operation.entity.case.viewalldiagnose',
    ASSOCIATE_CASES = 'operation.entity.case.associate',
    REASSIGN_PATIENT = 'operation.entity.case.reassign',
    EMIT_NOTIFICATION = 'operation.entity.case.emitnotification'
}
